import { settings } from '@rhim/design';
import { Space } from 'antd';
import styled from 'styled-components';

import { Button } from '../Button';
import { NotificationAction } from './types';

interface NotificationActionsProps {
  action: NotificationAction;
  onActionComplete: () => void;
}

export function NotificationActions({ action, onActionComplete }: Readonly<NotificationActionsProps>) {
  const handleButtonClick = (onClick?: () => void) => {
    onClick?.();
    onActionComplete();
  };

  switch (action.type) {
    case 'button':
      return (
        <Button
          className="notification-action-button"
          label={action.button.label}
          onClick={() => handleButtonClick(action.button.onClick)}
          size="x-small-32"
          autoFocus
        />
      );
    case 'button-bar':
      return (
        <Space>
          <Button
            className="notification-action-button"
            label={action.buttons.primaryButton.label}
            onClick={() => handleButtonClick(action.buttons.primaryButton.onClick)}
            size="x-small-32"
            autoFocus
          />
          <Button
            className="notification-action-button"
            label={action.buttons.secondaryButton.label}
            onClick={() => handleButtonClick(action.buttons.secondaryButton.onClick)}
            size="x-small-32"
            mode="ghost"
          />
        </Space>
      );
    case 'text-link':
      return (
        <StyledTextLink onClick={() => handleButtonClick(action.link.onClick)} autoFocus>
          {action.link.label}
        </StyledTextLink>
      );
    default:
      return null;
  }
}

const StyledTextLink = styled.button`
  background: none;
  border: none;
  padding: 0;
  cursor: pointer;
  font-family: ${settings.typography.FontFamily.Bold};
  font-size: ${settings.typography.FontSize.Medium};
  line-height: 24px;
  color: ${settings.colors.Primary.Blue_9};
  text-decoration: underline;
  text-underline-offset: 31%;

  &:hover {
    color: ${settings.colors.Primary.Blue_8};
  }

  &:active {
    color: ${settings.colors.Primary.Blue_7};
  }
`;
